import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '578px',
    padding: '30px',
    isolation: 'isolate',
    position: 'relative',
    display: 'grid',
    justifyContent: 'center',
    alignContent: 'center',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: '86px 0px 56px 0px',
    },
  },
  bannerText: {
    color: colors.white,
    margin: '0 auto',
    textAlign: 'center',
  },
  bannerTextHeader: {
    fontSize: '4.4rem',
    lineHeight: '4.8rem',
    fontWeight: 700,
    marginBottom: '20px',
    letterSpacing: '-1px',
    [theme.breakpoints.down('md')]: {
      fontSize: '3.8rem',
      lineHeight: '1.2',
    },
  },
  bannerTextSubheader: {
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
      fontSize: '2.4rem',
    },
  },
  searchBarRow: {
    margin: '64px auto 0 auto',
    maxWidth: '800px',
    [theme.breakpoints.down('md')]: {
      margin: '0 auto 0px auto',
    },
  },
  backgroundVideo: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: 'auto',
    width: 'auto',
    minHeight: '100%',
    minWidth: '100%',
    backgroundSize: 'cover',
    filter: 'brightness(30%)',
    transform: 'translate(-50%,-50%)',
    zIndex: -1,
  },
}));
